import React, { useEffect, useState } from "react";
import TableItem from "items/table/table";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { StandartButton } from "commons/form-controls";
import { SelectDropdown } from "commons/input-controls";
import { InputText } from "commons/input-controls";
import {ReactComponent as SearchIcon } from "assets/icons/search.svg";
import {ReactComponent as CancelIcon } from "assets/icons/close.svg";
import PaginatorContainer from "items/paginator/paginator-container";
import DropdownController from "items/dropdown/dropdown-controller";
import s from "./companies-table.module.scss";

const CompaniesTable = (props) => {

    const [rerender, setRerender] = useState(false);

    const setSelectedSort = (sort, type, e) => {
        if(sort === 'STATUS'){
            sortByStatus(type);
        }
        else{
            sortByOrder(sort, type)
        }
        
    }

    const sortByStatus = (status) => {
        props.setSortByStatus(status)
        setStatus(status)
    }

    const sortByOrder = (sort, type) => {
        setSort(sort, type);
        //props.setSortDirection(type)
        let items = type.split(" ");
        props.setSortBy(items[0], items[1]);
        setSortBy(items[0]);
        setRerender(!rerender);
        setSortByDirection(items[1])
    }

    const getSort = (sort) => {
        switch(sort){
            case 'ALPHABETIC':
                return alphabetic
            case 'CREATED_AT':
                return created
            case 'UPDATED_AT':
                return updated
            case 'STATUS':
                return status
        }
        
    }

    const setSort = (type, sort) => {
        switch(type){
            case 'ALPHABETIC':
                setAlphabetic(sort);
                break;
            case 'CREATED_AT':
                setCreated(sort);
                setUpdated('UPDATED_AT DESC');
                break;
            case 'UPDATED_AT':
                setUpdated(sort);
                setCreated('CREATED_AT DESC');
                break;
            /*case 'STATUS':
                setStatus();
                break;*/
        }
    }

    const getSelectedSort = (sort) => {
        let sorting = props.tableHeader.findIndex((f, i) => {return f.title === sort})
        let ret = sorting !== -1 ? props.tableHeader[sorting].items[0].short_name : sort
        return ret;
    }


    const getHeaderComponents = (headers, selected) => {
        let retHeaders = props.tableHeader && props.tableHeader.map((item, i) => {
            let t = item
            if(item.name === 'dropdown'){
                let titles = item.items.map((title)=>{return {title: props.getValue(title.title), short_name: title.short_name, name: title.name}});
                return <DropdownController
                            items={titles}
                            name={item.name}
                            callback={setSelectedSort}
                            selected={getSort(item.title)}
                            icon={null}
                            type={item.title}
                            short_name={'short_names'}
                        /> 
            }
            else{
                return props.getValue(item)
            }
        })
        return retHeaders
    }

    const [selectedItem, setSelectedItem] = useState(null);
    const [sortBy, setSortBy] = useState(props.sort);
    const [sortByDirection, setSortByDirection] = useState(props.sortDirection);
    const [alphabetic, setAlphabetic] = useState(getSelectedSort('ALPHABETIC'));
    const [created, setCreated] = useState(getSelectedSort('CREATED_AT'))
    const [updated, setUpdated] = useState(getSelectedSort('UPDATED_AT'))
    const [status, setStatus] = useState(props.status)
    const [searchText, setSearchText] = useState(props.searchText);
    const statuses = [ 'ACTIVE', 'CONTRACT_EXPIRED', 'BLOCKED', 'DELETED' ];
    const sorts = [ 'CREATED_AT', 'UPDATED_AT', 'ALPHABETIC'];
    const sortDirections = ['ASC', 'DESC'];
    const [searchStart, setSearchStart] = useState(false)
    let [tableHeaders, setTableHeaders] = useState(getHeaderComponents(props.tableHeaders));


    useEffect(() => {
        setSelectedItem(props.selected);
        setSortByDirection(props.sortDirection);
        //setAlphabetic(props.sort+" "+props.sortDirection);
        setStatus(props.status)
        setSortBy(props.sort);
        setTableHeaders(getHeaderComponents(props.tableHeaders));
        setSearchText(props.searchText);
        setRerender(!rerender);
    }, [props])

    const selectTableItem = (item) => {
        //props.setSelected(item);
        //setAlphabetic(props.sortBy);
        props.setCompanyId(props.companies.companies[item].id, props.companies.companies[item].name, item);
        props.setAccountId(null); 
        props.setTopicId(null)

    }

    const addNewCompany = () => {
        props.showRightMenu('create')
    }

    const addItemButton = <StandartButton 
        icon={PlusIcon} 
        fill={'white'}
        title={props.getValue('CREATE_COMPANY')}
        callback={addNewCompany}
    />

    const setText = (text) => {
        setSearchText(text)
        props.setSearchText(text)
    }

    const searchItem = (search) => {
        if(search){
            props.searchByText(searchText);
            setSearchStart(true)
        }
        else{
            setSearchText('')
            props.setSearchText('')
            props.searchByText('')
            setSearchStart(false)
            setRerender(!rerender)
        }
    }

    const setSelectedSortDirection = (sort) => {
        setSortByDirection(sort);
    }

    const cancelButton = searchStart ? <StandartButton icon={CancelIcon} callback={searchItem.bind(this, false)} background={'var(--background)'}/> : null

    const tableBlock = props.isSuperadmin && !props.adminCompanyId 
            ? <React.Fragment>
                <PaginatorContainer />
                <div className={s.SearchBlock}>
                    <InputText value={searchText} callback={setText}/>
                    {cancelButton}
                    <StandartButton disabled={!searchText || searchText == ''} title={props.getValue('SEARCH_BY_TITLE')} icon={SearchIcon} callback={searchItem.bind(this, true)} fill={'white'}/>
                </div>
                <TableItem 
                        data={[tableHeaders, props.data]}
                        height={320}
                        addItemButton={addItemButton}
                        hiddenColumns={props.hiddenColumns}
                        selectItem={selectTableItem}
                        selectedItem={selectedItem}
                        hiddenInEdit={[2,4]}        
            /> 
            </React.Fragment>
            : <div></div>
    return (
            tableBlock 
    )
}

export default CompaniesTable